module.exports = __webpack_public_path__ + "img/vova.1559c4fb.png";